import { Series } from '@types';

export const getZoneSeries = (series: Series[], zone: string) =>
  series.reduce<{
    highlights: Record<string, Series[]>;
    other: Record<string, Series[]>;
  }>(
    (data, curr) => {
      if (curr.location?.zone.toLowerCase() !== zone.toLowerCase()) return data;
      if (curr.isZoneHighlight) {
        data.highlights[zone] = data.highlights[zone]
          ? [...data.highlights[zone], curr]
          : [curr];
      } else {
        data.other[zone] = data.other[zone]
          ? [...data.other[zone], curr]
          : [curr];
      }
      return data;
    },
    { highlights: {}, other: {} }
  );
